import { apiClient } from "@/api/api-client.ts";
import type { Pagination } from "@/api/base-service.ts";
import type { City } from "@/features/dashboard/types/city.ts";

const cityService = {
	list: async (params = {}) => {
		const response = await apiClient.get<{ data: City[]; meta: Pagination }>("/cities", { params });

		return response.data;
	},
};

export default cityService;
